module.exports = "<div *ngIf=\"!!product\">\n  <div class=\"product-description\">{{ product.descriptions | localizedtext }}</div>\n</div>\n"